var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex-1 button",attrs:{"disabled":_vm.pending},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.pending)?_c('UiLoading'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }